<template>
</template>

<script>
    import VueFormGenerator from "vue-form-generator/dist/vfg.js";

    Vue.use(VueFormGenerator);

    export default {

        props: ["model", "schema"],


        methods: {

            init: function () {


                this.model.customer.address = "";
                this.model.customer.postal_code = "";
                this.model.customer.city = "";


                let fields = [
                    {
                        type: "input",
                        inputType: "text",
                        label: "Naslov",
                        model: "customer.address",
                        required: true,
                        validator: VueFormGenerator.validators.string,
                        styleClasses: 'col-sm-12'
                    },
                    {
                        type: "input",
                        inputType: "text",
                        label: "Poštna številka",
                        model: "customer.postal_code",
                        required: true,
                        validator: VueFormGenerator.validators.string,
                        styleClasses: 'col-sm-6',
                    },
                    {
                        type: "input",
                        inputType: "text",
                        label: "Kraj",
                        model: "customer.city",
                        required: true,
                        validator: VueFormGenerator.validators.string,
                        styleClasses: 'col-sm-6',
                    },
                ];

                for(let i = 0; i < fields.length; i++) {
                    this.schema.groups[0].fields.push(fields[i]);
                }
            }
        }

    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modules/CustomerAddress.vue